var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRightDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.71 6.23313C15.0967 6.61985 15.0967 7.24788 14.71 7.6346L8.76996 13.5746C8.38324 13.9613 7.75521 13.9613 7.36849 13.5746C6.98177 13.1879 6.98177 12.5599 7.36849 12.1731L12.6093 6.93232L7.37159 1.69151C6.98487 1.30479 6.98487 0.676758 7.37159 0.290039C7.7583 -0.0966797 8.38634 -0.0966797 8.77305 0.290039L14.7131 6.23004L14.71 6.23313Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70996 6.23313C8.09668 6.61985 8.09668 7.24788 7.70996 7.6346L1.76996 13.5746C1.38324 13.9613 0.755211 13.9613 0.368492 13.5746C-0.0182266 13.1879 -0.0182266 12.5599 0.368492 12.1731L5.6093 6.93232L0.371585 1.69151C-0.0151329 1.30479 -0.0151329 0.676758 0.371585 0.290039C0.758304 -0.0966797 1.38634 -0.0966797 1.77305 0.290039L7.71305 6.23004L7.70996 6.23313Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightDouble);
export default __webpack_public_path__ + "static/media/icon-arrow-right-double.0872ce5f6c795ffe9d426fb07ee417a1.svg";
export { ForwardRef as ReactComponent };